// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".details_nei[data-v-7a7db8d4]{font-size:14px}.widthWhite hgroup p span[data-v-7a7db8d4]{margin:0 20px}.widthWhite hgroup p[data-v-7a7db8d4]{margin-top:20px;font-size:12px;color:#666}.widthWhite hgroup h6[data-v-7a7db8d4]{font-weight:400;font-size:16px;text-align:center}.widthWhite hgroup[data-v-7a7db8d4]{padding:0 0 20px 0;margin-bottom:20px;border-bottom:1px solid #e6e6e6}", ""]);
// Exports
module.exports = exports;
